<template>
  <div>
    <div
      class="cookie-btn"
      @mouseenter="hovered = true"
      @mouseleave="hovered = false"
      @click="openPreferences"
    >
      <span class="cookie-text">Cookies verwalten</span>
    </div>
  </div>
</template>

<script>
import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";
import translations from "@/language/de/translations.json";
import { mapGetters } from "vuex";
import Matomo from "@/utils/Matomo";

export default {
  name: "CookieConsent",
  data() {
    return {
      hovered: false,
    };
  },
  watch: {
    "$vuetify.theme.global.current.dark"() {
      this.applyDarkMode();
    },
    user(newUser) {
      if (!newUser?.id) return;
      Matomo.trackEvent(["setUserId", newUser.id]);
    },
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
  },
  methods: {
    initCookieConsent() {
      CookieConsent.run({
        guiOptions: {
          consentModal: {
            layout: "box",
            position: "bottom right",
            transition: "slide",
          },
          preferencesModal: {
            layout: "box",
            transition: "slide",
          },
        },
        categories: {
          necessary: {
            enabled: true,
            readOnly: true,
          },
          analytics: {
            enabled: false,
            autoClear: {
              cookies: [
                {
                  name: /^_pk_/,
                },
              ],
            },
          },
        },
        language: {
          default: "de",
          translations: { de: translations.cookieConsent },
        },
        onChange: ({ cookie }) => {
          if (cookie.categories?.includes("analytics")) {
            Matomo.trackEvent(["setConsentGiven"]);
            Matomo.trackEvent(["rememberConsentGiven"]);
          } else {
            Matomo.trackEvent(["forgetConsentGiven"]);
          }
        },
        onConsent: ({ cookie }) => {
          if (cookie.categories?.includes("analytics")) {
            Matomo.trackEvent(["setConsentGiven"]);
            Matomo.trackEvent(["rememberConsentGiven"]);
          } else {
            Matomo.trackEvent(["forgetConsentGiven"]);
          }
        },
      });
    },
    openPreferences() {
      CookieConsent.showPreferences();
    },
    applyDarkMode() {
      const ccWrapper = document.getElementById("cc-main");
      if (!ccWrapper) return;
      ccWrapper.classList.toggle(
        "cc--darkmode",
        !!this.$vuetify.theme.global.current?.dark
      );
    },
  },
  mounted() {
    this.initCookieConsent();
    this.applyDarkMode();
  },
};
</script>

<style scoped>
.cookie-btn {
  position: fixed;
  bottom: 50px;
  right: -145px;
  transform: translateY(-50%);
  background-color: #0099db;
  color: white;
  border-radius: 8px 0 0 8px;
  padding: 10px 16px;
  width: 160px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  transition: right 0.3s ease, background-color 0.3s ease;
  z-index: 9999;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.cookie-btn:hover {
  right: 0;
}

.cookie-text {
  font-size: 15px;
  margin-left: 8px;
  white-space: nowrap;
}
</style>
